<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> نظرات مشتری '{{Customer_Inner.name}}' </h5>
     <br/>

     <button  (click)="OnSet_Back_CommentView()"  type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>



      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>توضیحات</th>
              <th>درجه اهمیت</th>
              <th>وضیعت</th>
              <th>ثبت کننده</th>
              <th>تاریخ ثبت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Comment
            | paginate
                    : {
                        id: 'DataList_Comment',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Comment).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Comment.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>

              <th>
                <p *ngIf="item.code=='0'" style="color: #489b39;">عادی</p>
                <p *ngIf="item.code=='1'" style="color: #9b7439;">مهم</p>
                <p *ngIf="item.code=='2'" style="color: #9b394e;">حیاتی</p>

              </th>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item" (click)="openModal_Edit(templateEdit,item)"><i class="fa fa-edit"></i> ویرایش </a>
                      <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                      <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Comment"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">تایید غیرفعال اطلاعات
      '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">تایید فعال اطلاعات
      '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ویرایش نظر مشتری '{{Data_Seleted_Comment.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="EditDsc"  name="EditDsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="Edit()"> ویرایش <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">بستن</button>
  </div>
</ng-template>
